import { defineMessages } from 'react-intl';

export default defineMessages({
    businessDetails: {
        id: '_.business_details',
        defaultMessage: 'Enter your business details'
    },
    tradingName: {
        id: '_.company.trading_name',
        defaultMessage: 'Trading name'
    },
    companyType: {
        id: '_.company.company_type',
        defaultMessage: 'What type of company are you?'
    },
    businessType: {
        id: '_.company.business_type',
        defaultMessage: 'What does the business do?'
    },
    legalForm: {
        id: '_.company.legal_form',
        defaultMessage: 'Choose a legal form'
    },
    buildingNumber: {
        id: '_.address.building_number',
        defaultMessage: 'Building number'
    },
    addressLine1: {
        id: '_.address.address_line_1',
        defaultMessage: 'Address line 1'
    },
    addressLine2: {
        id: '_.address.address_line_2',
        defaultMessage: 'Address line 2'
    },
    postcode: {
        id: '_.address.postcode',
        defaultMessage: 'Postcode'
    },
    town: {
        id: '_.address.town',
        defaultMessage: 'Town'
    },
    checkingDetails: {
        id: '_.checking_details',
        defaultMessage: "We're checking your details..."
    },
    isYourBusinessInTheList: {
        id: '_.is_business_in_list',
        defaultMessage: 'Is your business in the list?'
    },
    businessNotInList: {
        id: '_.business_not_in_list',
        defaultMessage: "My business isn't in the list"
    },
    introductionText: {
        id: '_.company_search_dialog_de.introduction_text',
        defaultMessage: `We've found {businessListLength, plural, 
            one {one business that matches} 
            other {a few businesses that match}}
            your details`
    }
});
